import { ErrorBoundary } from '../ErrorBoundary';
import { MaybeHasCanceledSubscriptions } from './MaybeHasCanceledSubscriptions';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const ResurrectionBanner = ({
  featureLimitName,
  logExposure,
  treatments
}) => /*#__PURE__*/_jsx(ErrorBoundary, {
  fallback: /*#__PURE__*/_jsx(_Fragment, {}),
  children: /*#__PURE__*/_jsx(MaybeHasCanceledSubscriptions, {
    featureLimitName: featureLimitName,
    logExposure: logExposure,
    treatments: treatments
  })
});